var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path297",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43637",
    "data-name": "Group 43637",
    transform: "translate(-1287 -4245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16142",
    "data-name": "Rectangle 16142",
    width: 16,
    height: 16,
    transform: "translate(1287 4245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g291",
    transform: "translate(1288 4928.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g293",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g295",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g301",
    transform: "translate(0.547 0.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path303",
    d: "M-308.213,0a6.453,6.453,0,0,1,6.453,6.453,6.453,6.453,0,0,1-6.453,6.453,6.453,6.453,0,0,1-6.453-6.453,6.433,6.433,0,0,1,1.89-4.563",
    transform: "translate(314.666)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g305",
    transform: "translate(0.547 2.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path307",
    d: "M0,0H2.151V2.151",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g309",
    transform: "translate(7 2.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path311",
    d: "M0,0V4.3H3.227",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketHistory);
export default __webpack_public_path__ + "static/media/ticket-history.b05af0b126e29023e1012353cd99f9d5.svg";
export { ForwardRef as ReactComponent };